var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(this.$store.state.session.auth)?_c('v-container',[_c('loading-bar'),_c('toolbar'),_c('navigation-drawer',{key:this.$store.state.session.data.role}),_c('system-snackbar')],1):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('transition',{attrs:{"mode":"out-in","name":"slide-right"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }